<template>
  <Card border rounded class="overflow-hidden p-0">
    <Flex justify-between items-center class="h-8 border-b">
      <IconInput icon="fa-chevron-left" class="border-r" @click="prevYear" />
      <span class="font-semibold">{{ year }}</span>
      <IconInput icon="fa-chevron-right" class="border-l" @click="nextYear" />
    </Flex>

    <div class="grid grid-cols-3" v-if="props.range">
      <div
        v-for="(month, i) in months"
        :key="i"
        class="text-sm hover:bg-gray-200 p-1 text-center cursor-pointer"
        @click="selectMonthRange(i + 1, year)"
        :class="{
          'bg-gray-100 rounded': selectedMonth.includes(i + 1),
        }"
      >
        {{ month }}
      </div>
    </div>
    <div class="grid grid-cols-3" v-else>
      <div
        v-for="(month, i) in months"
        :key="i"
        class="text-sm hover:bg-gray-200 p-1 text-center cursor-pointer"
        @click="selectMonth(i + 1)"
        :class="{'bg-gray-300 text-white rounded': isSelected(i + 1)}"
      >
        {{ month }}
      </div>
    </div>
  </Card>
</template>
<script setup>
import {ref, computed} from "vue"

const props = defineProps({
  modelValue: String, // formato: 'YYYY-MM'
  range: Boolean,
})
const emits = defineEmits(["update:modelValue"])

const date = new Date()
const year = ref(date.getFullYear())

const startMonth = ref(null)
const endMonth = ref(null)

const parseDate = (dateStr) => {
  if (!dateStr) return null
  const [y, m] = dateStr.split(" ")[0].split("-").map(Number)
  return {year: y, month: m}
}

const selectedMonth = computed(() => {
  const start = parseDate(startMonth.value)
  const end = parseDate(endMonth.value)
  const currentViewYear = year.value
  const highlightedMonths = [] // Check if start month is in the current view

  if (start && start.year === currentViewYear) {
    highlightedMonths.push(start.month)
  } // Check if end month is in the current view

  if (end && end.year === currentViewYear) {
    // Avoid duplicates if start and end are the same month
    if (!start || start.month !== end.month || start.year !== end.year) {
      highlightedMonths.push(end.month)
    }
  }

  return highlightedMonths
})

const months = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]

const prevYear = () => {
  year.value--
}
const nextYear = () => {
  year.value++
}

const selectMonth = (month) => {
  const formattedMonth = String(month).padStart(2, "0")
  const formattedDate = `${year.value}-${formattedMonth}`
  emits("update:modelValue", formattedDate)
}

const selectMonthRange = (month, year) => {
  const formattedMonth = String(month).padStart(2, "0")
  if (startMonth.value === null) {
    startMonth.value = `${year}-${formattedMonth}-01 00:00:00`
    return
  }

  if (endMonth.value === null) {
    // Parse start month/year to compare correctly
    const startYear = parseInt(startMonth.value.substring(0, 4))
    const startMonthNum = parseInt(startMonth.value.substring(5, 7))

    const selectedYearMonthNum = year * 100 + month
    const startYearMonthNum = startYear * 100 + startMonthNum

    if (selectedYearMonthNum < startYearMonthNum) {
      clearRange()
      startMonth.value = `${year}-${formattedMonth}-01 00:00:00`
    } else {
      endMonth.value = `${year}-${formattedMonth}-31 23:59:59`
    }
    const updatedValue = [startMonth.value, endMonth.value]
    console.log(updatedValue)
    emits("update:modelValue", updatedValue)

    return
  }
  clearRange()
}

const isSelected = (month) => {
  if (!props.modelValue) return false
  if (Array.isArray(props.modelValue)) return false
  if (typeof props.modelValue !== 'string') return false
  const [y, m] = props.modelValue.split("-").map(Number)
  return y === year.value && m === month
}

const clearRange = () => {
  startMonth.value = null
  endMonth.value = null
}
</script>
